import { render, staticRenderFns } from "./Window.vue?vue&type=template&id=220079c0&scoped=true&lang=pug"
import script from "./Window.vue?vue&type=script&lang=ts"
export * from "./Window.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "220079c0",
  null
  
)

export default component.exports